export default __webpack_public_path__ + "static/media/create-rampver-account.3bd2c4b2.png";